import { combineReducers } from 'redux-immutable';
import labels from './labels';
import cruises from './cruises';
import sort from './sort';
import filter from './filter';
import message from './message';

const cruiseListApp = (common) => {
  return combineReducers({
    labels,
    cruises,
    sort,
    filter,
    message,
    common,
  });
}; 

export default cruiseListApp;
